const featureSections = [
  {
    title: 'Customised business number you can take anywhere:',
    description:
      'Your WhatsApp for Business number unlocks a suite of built-in tools to streamline communication, strengthen relationships, and simplify daily operations.',
  },
  {
    title: 'Embed the virtual phone number on your website:',
    description:
      'Add your WhatsApp Business contact information to your website using a QR code or clickable link, so customers can reach you in seconds.',
  },
  {
    title: 'Automation & messaging tools:',
    items: [
      'Automated messages: Set greeting or away messages for instant replies - one of the most valuable built-in tools for improving customer response time.',
      'Quick replies: Reuse saved responses to common questions.',
      'Broadcast lists: Send updates to multiple customers without a group chat.',
      'Interactive messages: Use list messages and reply buttons for richer engagement.',
    ],
  },
  {
    title: 'Organisation & management:',
    items: [
      'Business profile: Add hours, services, and key details for a professional presence.',
      'Contact labels: Organise chats with labels like "New Customer" or "Payment Pending."',
      'Message statistics: Track WhatsApp messages sent, delivered, and read to monitor response times and customer experience.',
    ],
  },
  {
    title: 'Sales, marketing campaigns & WhatsApp ads:',
    items: [
      'Catalogues: Showcase products in a mobile storefront that customers can browse.',
      'Entry points: Use short links, QR codes, or buttons on your social profiles.',
      'Click-to-WhatsApp ads: Turn social-media ads into instant conversations.',
    ],
  },
]

const WABusinessFeatures = () => {
  return (
    <div
      className='d-flex flex-column align-items-center align-self-center w-100'
      style={{
        maxWidth: 1074,
      }}
    >
      <div className='text-center d-flex flex-column gap-3 mb-lg-14 mb-10'>
        <h2 className='fs-fluid-36-80 lh-119 lh-lg-105 fw-semibold mb-lg-7 mb-2'>
          WhatsApp for Business features <br className='d-none d-lg-block' /> &
          built-in tools deep dive.
        </h2>
        <p className='fs-fluid-18-24 fw-semibold color-grey5 mb-0'>
          Your WhatsApp for Business number unlocks a suite of built-in tools to
          streamline communication, strengthen relationships, and simplify daily
          operations.
        </p>
      </div>

      <div className='w-100 d-flex flex-column gap-8 pt-9'>
        {featureSections.map((section) => (
          <div className='d-flex flex-column gap-3 lh-140' key={section.title}>
            <h3 className='fs-fluid-16-32 fw-bold mb-0'>{section.title}</h3>

            {section.description && (
              <p className='fs-fluid-16-22 fw-semibold color-grey5 mb-0'>
                {section.description}
              </p>
            )}

            {section.items && (
              <ul className='fs-fluid-16-24 ms-4 fw-semibold color-grey5 mb-0 ps-3'>
                {section.items.map((item) => (
                  <li className='mb-3 ps-0' key={item}>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default WABusinessFeatures
